import React, { useEffect, useState } from "react";
import Modal from "../../components/Modal";
import { UserPlusIcon } from "@heroicons/react/24/outline";
import PrimaryLinkButton from "../../components/PrimaryLinkButton";
import Input from "../../components/Input";
import Select from "../../components/Select";

const initUserObj = { email: "", role: "admin", error: "" };

const AddTeamsModal = ({ isOpen, onClose, onSuccess, fetchTeam, api }) => {
  const [loading, setLoading] = useState(false);

  const [user, setUser] = useState([initUserObj]);

  // Email Validation Function
  const validateEmail = email => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  // Handle Input Change
  const handleInputChange = (index, field, value) => {
    setUser(prevUsers =>
      prevUsers.map((userObj, i) =>
        i === index ? { ...userObj, [field]: value, error: "" } : userObj
      )
    );
  };

  // Add New User
  const addMultiUser = () => {
    setUser(prevObj => [...prevObj, initUserObj]);
  };

  const createUser = async e => {
    try {
      e.preventDefault();
      setLoading(true);
      let isValid = true;

      let updatedUsers = user.map(userObj => {
        if (!validateEmail(userObj.email)) {
          isValid = false;
          return { ...userObj, error: "Invalid email address" };
        }
        return userObj;
      });

      if (!isValid) {
        setUser(updatedUsers);
        setLoading(false);
        return;
      }

      const { data } = await api.post("/api/team/add-member", user);

      updatedUsers = user.map(u => {
        const responseEntry = data.find(res => res.email === u.email);
        return responseEntry ? { ...u, error: responseEntry.error || "" } : u;
      });

      const failedUsers = updatedUsers.filter(u => u.error);

      setUser(failedUsers);

      if (failedUsers.length === 0) {
        onSuccess();
        onClose();
      }
    } catch (e) {
      console.log("Error:", e);
    } finally {
      fetchTeam();
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      setUser([initUserObj]);
    }
  }, [isOpen]);

  return (
    <Modal
      startIcon={
        <div className="p-2 rounded-xl border">
          <UserPlusIcon className="size-6" />
        </div>
      }
      title="Invite Team Members"
      description="Invite your team members to manage your support"
      open={isOpen}
      onClose={onClose}
      onSubmit={createUser}
      isSubmitting={loading}
      submitLabel="Send Invites"
    >
      <div className="space-y-4">
        {user.map((userObj, index) => (
          <div key={index} className="flex items-center justify-between">
            <div className="flex flex-1 gap-4">
              {/* Email Input */}
              <div className="flex-1">
                <label className="text-sm text-gray-600">Email address</label>
                <Input
                  error={userObj.error}
                  value={userObj.email}
                  onChange={e =>
                    handleInputChange(index, "email", e.target.value)
                  }
                  placeholder="user@google.com"
                />
              </div>

              {/* Role Dropdown */}
              <div>
                <label className="text-sm text-gray-600">Role</label>
                <Select
                  value={user[index].role || "admin"}
                  onChange={e =>
                    handleInputChange(index, "role", e.target.value)
                  }
                  options={[
                    { value: "admin", label: "Admin" },
                    { value: "member", label: "Member" },
                  ]}
                />
              </div>
            </div>
          </div>
        ))}

        <PrimaryLinkButton onClick={addMultiUser} type="button">
          + Add another
        </PrimaryLinkButton>
      </div>
    </Modal>
  );
};

export default AddTeamsModal;
